'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Masonry = styled__default["default"].div(
  ({ columnCount, gap }) => `
    display: grid;
    grid-template-columns: repeat(${columnCount}, auto);
    grid-column-gap: ${gap}px;
    height: calc(100% + ${gap}px);
    margin-bottom: ${-gap}px;
  `
);
const MasonryImageWrapper = styled__default["default"].div(
  ({ gap }) => `
  margin-bottom: ${gap}px;
  display: flex;
  `
);

exports.Masonry = Masonry;
exports.MasonryImageWrapper = MasonryImageWrapper;
